import React, { useState } from "react";
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { AiFillCloseCircle } from "react-icons/ai";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { BiX } from "react-icons/bi";
import { applyTrivvyTitleText, getTrivvyTitleText } from '../data'

export default function RenamePopup({ onClose, open, item, onUpdateItem }) {
  const originalName = getTrivvyTitleText(item);
  const [name, setName] = useState(originalName);

  const handleRename = () => {
    if (name === originalName) {
      onClose();
      return;
    }
    axios
      .put(url.editTrivia(item._id), {
        // The new text is folded back into the stored markup so the styling
        // applied on the edit page survives a rename.
        updateData: { name: applyTrivvyTitleText(item.name, name) },
      })
      .then(({ data }) => {
        const updated = data.data.trivia;
        console.log({ updated });
        onUpdateItem(updated);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <Modal isOpen={open} centered size="sm">
     <ModalHeader
         className="trivia_modal_header_bg"
            close={
              <BiX
                className="cursor-pointer"
                color="gray"
                size={30}
                onClick={() => onClose()}
              />
            }
          >Rename this Trivia?</ModalHeader>

      <ModalBody className="px-3 pb-5">
      
        <div className="mt-4">
          <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter name here"
          />
        </div>
      </ModalBody>

      <ModalFooter>
        <Button className="trivia-action-button-secondary" onClick={() => onClose()}>Cancel</Button>
        <Button
          disabled={name && name.length < 2}
          className="trivia-action-button-main"
          onClick={handleRename}
        >
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
}
